import { clearString } from "@/utils/functions";
import api from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect, select } from "redux-saga/effects";
import environment from "@/settings/environment";
import { setUser } from "@/redux/ducks/user";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
    plate: string;
    callback: (success: boolean, code?: string) => void;
}

export interface AuthAction {
    type: string;
    payload: Fetch;
}

export default function* authorize({
    payload,
}: AuthAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const getUser = (state: ReducersTypes) => state.userReducer;
        // @ts-expect-error
        const user: ReducersTypes['userReducer'] = yield select(getUser);

        const data = {
            companyIdentification: environment.api.companyIdentification,
            licensePlate: clearString(payload.plate),
            channel: environment.api.channel
        }
        const response = yield call(api.post, `/v1/customers/authorize`, data);
        
        if (response?.data?.data?.code === 0) {
            yield put(setUser({
                ...user,
                accessToken: response?.data?.data?.accessToken,
            }));
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false, "again");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}